import {useState} from "react";
import {format} from "date-fns";

const Header = (props) => {
  const userData = props.userData;

  const toggleSidebar = () => {
    document.getElementById('side-bar').classList.toggle('d-none');
  };

  const [ clock, setClock ] = useState(format(new Date(), 'EEEE, d MMMM yyyy HH:mm:ss'));
  setInterval(() => setClock(format(new Date(), 'EEEE, d MMMM yyyy HH:mm:ss')), 1000);

  return (
    <div className="d-flex align-items-center justify-content-between p-4 h-45">
      <div className="d-md-block d-none">
        <span className="title">{clock}</span>
      </div>
      <div className="d-md-none d-sm-block">
        <span className="title"><button className="btn btn-link" onClick={() => toggleSidebar()}><i className="bi bi-list"/></button></span>
      </div>
      <div className="d-flex align-items-center">
        <a href="/profile">
          <p className="text-end me-2 mb-0">
            <strong className="title">{userData.full_name}</strong>
            <br/>
            <span className="text-muted">{userData.user_department}</span>
          </p>
        </a>
        <a href="/profile"><img className="rounded-circle " src={userData.google_photo} width={30} alt={userData.full_name} referrerPolicy="no-referrer"/></a>
      </div>
    </div>
  );
};

export default Header;